<template lang="pug">
b-modal#raiseDepositTicketGateway(
  ref="raiseDepositTicketGateway"
  :title="$t('ui.combine.raise_deposit_ticket_gateway')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    b-form-group(:label="$t('ui.account_id')" disabled).mb-0
      DebounceInput(
        size="sm"
        ref="account_id"
        required
        alphaNum
        type="text"
        :dirty="$v.account_id.$dirty"
        :error="$v.account_id.$error"
        v-model.trim.lazy="$v.account_id.$model"
        :disabled="loading"
        :maxLength="$v.account_id.$params.maxLength.max"
      )
      ValidateResult(:value="$v.account_id" :name="$t('ui.account_id')")

    b-form-group(:label="$t('ui.payment_mode')").mb-0
      //- b-form-select(v-model="payment_mode" size="sm" :disabled="loading" @input="getProviderList")
      b-form-select(v-model="payment_mode" size="sm" :disabled="loading")
        option(value="" selected) {{ $t("message.select_option") }}
        option(v-for="option in paymentOptionList" :value="option.payment_mode") {{ option.payment_desc }}
      ValidateResult(:value="$v.payment_mode" :name="$t('ui.payment_mode')")
    
    //- b-form-group(:label="$t('ui.gateway_acc')").mb-0
    //-   b-form-select(v-model="gateway_acc" size="sm" :disabled="loading")
    //-     option(value="" selected) {{ $t("message.select_option") }}
    //-     //- option(v-for="option in providerList" :value="option.provider_group") {{ option.provider_group }}
    //-     option(v-for="option in providerList" :value="option.provider_code") {{ option.provider_code }}
    //-   ValidateResult(:value="$v.gateway_acc" :name="$t('ui.gateway_acc')")

    b-form-group(:label="$t('ui.promotion')").mb-0
      b-form-select(v-model="promotion_id" size="sm" :disabled="loading")
        option(value="" selected) {{ $t("message.select_option") }}
        option(v-for="option in promoList" :value="option.promotion_id") {{ option.promotion_id }} - {{ option.promotion_name }}
    b-form-group(:label="$t('ui.amount')").mb-0
      DebounceInput(
        size="sm"
        ref="deposit_amount"
        required
        type="text"
        :dirty="$v.deposit_amount.$dirty"
        :error="$v.deposit_amount.$error"
        v-model.trim.lazy="$v.deposit_amount.$model"
        :disabled="loading"
      )
      ValidateResult(:value="$v.deposit_amount" :name="$t('ui.amount')")
    b-form-group(:label="$t('ui.remark')").mb-3
      b-form-textarea(v-model="remark" style="height:80px;" :disabled="loading")
      ValidateResult(:value="$v.remark" :name="$t('ui.remark')")
    //- div.row
    //-   div.col 
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-cancel")
    SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>
<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import PromotionLookup from "@/library/PromotionLookup";
import DebounceInput from "@/library/DebounceInput";
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ValidateResult,
    PromotionLookup
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      loading: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      locale: {
        format: "YYYY-MM-DD HH:mm:ss",
        useCurrent: true
      },
      account_id: '',
      deposit_amount: '',
      promotion_id: '',
      remark: '',
      payment_mode: '',
      // gateway_acc: '',
      promoList: [],
      paymentOptionList: [],
      providerList: []
    };
  },
  computed: {
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    account_id: {
      required,
      alphaNum,
      maxLength: maxLength(20)
    },
    deposit_amount: {
      required,
      decimal,
      greaterThanZero
    },
    payment_mode: {
      required
    },
    // gateway_acc: {
    //   required,
    // },
    remark: {
      required
    }
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    getPromotionList: function() {
      let url = config.promotionLookupDepositUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: this.item.account_id,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.promoList = response.data.dt.filter(d => { return d.promotion_id != null && d.payment_option_list == null && d.status == true });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getPaymentOptionList: function() {
      let url = config.paymentOptionListUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                // this.paymentOptionList = response.data.dt;
                let list = response.data.dt;
                if (list.length > 0) {
                  let result = list.filter(item => item.payment_mode.toUpperCase() !== "MANUAL" && item.status == true) // Exclude "MANUAL" and show status true

                  this.paymentOptionList = result;
                } else {
                  this.paymentOptionList = [];
                }
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    // getProviderList() {
    //   // let url = config.paymentProviderGbListUrl();
    //   let url = config.paymentOptionProviderListUrl();

    //   var json = {
    //     action_by: this.$store.getters.loginId,
    //     auth_token: this.$store.getters.sessionToken,
    //     operator_id: this.operatorID,
    //     payment_mode: this.payment_mode,
    //     gateway_status: true
    //   };

    //   this.loading = true;
    //   this.$http.post(url, json).then(
    //     function(response) {
    //       this.loading = false;
    //       // Success
    //       try {
    //         if (response) {
    //           this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

    //           this.feedback.status = response.data.statusdesc;
    //           if (this.feedback.success == true) {
    //             // this.gateway_acc = "";
    //             this.providerList = response.data.dt;
    //           } else {
    //             if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //           }
    //         }
    //       } catch (error) {
    //         this.feedback.success = false;
    //         this.feedback.status = errorTags.request.failed;
    //         this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //       }
    //     },
    //     function(response) {
    //       this.loading = false;
    //       // Error
    //       this.feedback.success = false;
    //       this.feedback.status = errorTags.request.failed;
    //       this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
    //     }
    //   );
    // },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.ticketDepositGatewayApproveUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          member_id: this.item.account_id,
          deposit_amount: this.deposit_amount,
          // gateway_acc: this.gateway_acc,
          promotion_id: this.promotion_id,
          payment_mode: this.payment_mode,
          remark: this.remark,
          // payment_gateway: this.gateway_acc,
          exchange_currency: null,
          exchange_rate: null,
          base_rate: null,
          exchanged_amount: null,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.raiseDepositTicketGateway.hide();
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                  this.$refs.raiseDepositTicketGateway.hide();
                  // this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.account_id = this.item.account_id;
      this.deposit_amount = '';
      // this.gateway_acc = '';
      this.payment_mode = '';
      this.promotion_id = '';
      this.remark = '';
      this.getPromotionList();
      this.getPaymentOptionList();
    }
  }
};
</script>